import React,{useState} from "react";
import { Link } from "react-router-dom";

function Header(){

  const [menuOpen, setMenuOpen] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);

    return(
        <>
    {/* Header Start */}
	<header className="main-header">
		<div className="header-sticky">
			<nav className="navbar navbar-expand-lg">
				<div className="container">
					{/* Logo Start */}
					<a className="navbar-brand" href="./">
						<img src="/images/logo.svg" alt="Logo"/>
					</a>
					{/* Logo End */}

					{/* Main Menu Start */}
					<div className={`collapse navbar-collapse main-menu ${menuOpen ? "show" : ""}`}>
                        <div className="nav-menu-wrapper">
                            <ul className="navbar-nav mr-auto" id="menu">
                                        <li className="nav-item"><Link className="nav-link" to={`/`} onClick={() => setMenuOpen(false)}>Home</Link></li>
                                
                                <li className="nav-item"><Link className="nav-link" to={`/about`} onClick={() => setMenuOpen(false)}>About Us</Link></li>
                                <li className="nav-item"><Link className="nav-link" to={`/service`} onClick={() => setMenuOpen(false)}>Services</Link></li>
                                <li className={`nav-item submenu ${openSubmenu === "gallery" ? "active" : ""}`}>
                                <Link
                                    className="nav-link"
                                    onClick={() =>
                                        setOpenSubmenu(openSubmenu === "gallery" ? null : "gallery")
                                    }
                                >
                                    Gallery
                                </Link>

                                <ul>
                                    <li className="nav-item">
                                        <Link
                                            className="nav-link"
                                            to="/photo"
                                            onClick={() => {
                                                setMenuOpen(false);
                                                setOpenSubmenu(null);
                                            }}
                                        >
                                            Photo
                                        </Link>
                                    </li>

                                    <li className="nav-item">
                                        <Link
                                            className="nav-link"
                                            to="/video"
                                            onClick={() => {
                                                setMenuOpen(false);
                                                setOpenSubmenu(null);
                                            }}
                                        >
                                            Video
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                                <li className="nav-item"><Link className="nav-link" to={`/news`} onClick={() => setMenuOpen(false)}>News & Events</Link></li>
                                <li className="nav-item"><Link className="nav-link" to={`/contact`} onClick={() => setMenuOpen(false)}>Contact Us</Link></li>
                                <li className="nav-item highlighted-menu"><Link className="nav-link" to={`/appointment`} onClick={() => setMenuOpen(false)}>book appointment</Link></li>                               
                            </ul>
                        </div>
                        {/* Let’s Start Button Start */}
                        <div className="header-btn d-inline-flex">
                            <Link to={`/appointment`} className="btn-default" onClick={() => setMenuOpen(false)}>book appointment</Link>
                        </div>
                        {/* Let’s Start Button End */}
					</div>
					{/* Main Menu End */}
					<div className="navbar-toggle" onClick={() => setMenuOpen(!menuOpen)}>☰</div>
                    </div>
			</nav>
			<div className="responsive-menu"></div>
		</div>
	</header>
	{/* Header End */}        
        </>
    );
}

export default Header;